import { set } from 'lodash-es';

import {
  AlertModal,
  Dashboard,
  ErrorApp,
  Login,
  Password,
  QrCode,
  SignatureConfirmation,
  Sponsorship,
  DeletedAccount,
} from '@/views';

import Transaction from '@/views/default/Transaction.vue';

import DashboardFooter from '@/components/common/layout/DashboardFooter.vue';
import Header from '@/components/common/layout/Header.vue';

import clientChildren from './children/client';

const header = Header;

const extra = [
  {
    path: '/verify/:id?',
    components: {
      default: QrCode,
      header,
    },
    meta: {
      logged: false,
    },
  },
  {
    path: '/signature',
    name: 'signatureConfirmation',
    component: SignatureConfirmation,
  },
  {
    path: '/password',
    name: 'password',
    components: {
      default: Password,
      header,
    },
  },
  {
    path: '/failure/:name?',
    name: 'errorView',
    components: {
      default: ErrorApp,
      header,
    },
  },
  {
    path: '/login',
    name: 'loginView',
    components: {
      default: Login,
      header,
    },
  },
  {
    path: '/unicorn-login',
    name: 'unicornLoginView',
    components: {
      default: Login,
      header,
    },
  },
  {
    path: '/',
    redirect: '/client',
  },
  {
    path: '/client',
    components: {
      default: Dashboard,
      modal: AlertModal,
      footer: DashboardFooter,
    },
    children: clientChildren,
    meta: {
      logged: true,
    },
  },
  {
    path: '/sponsorship',
    name: 'sponsorshipView',
    components: {
      default: Sponsorship,
      header,
    },
  },
  {
   path: '/deleted-account',
   name: 'DeletedAccount',
   components: {
     default: DeletedAccount,
     header,
   },
  },
  {
    path: '/client/transaction/:id',
    name: 'Transaction',
    components: {
      default: Transaction,
      header,
    },
    beforeEnter: (to, from, next) => {
      if (to.query.token) {
        next();
      } else {
        next('/login');
      }
    },
  },
].map((elem) => set(elem, 'meta.isExtra', true) && elem);

const routes = [...extra];
export default routes;
